var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25875_12132)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#3C2190",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8029 17.6229C22.8029 19.7509 21.2635 21.5156 19.2454 21.8494C19.0198 21.8869 18.7882 21.9071 18.552 21.9071C18.3159 21.9071 18.0844 21.8867 17.8587 21.8494C15.8409 21.5156 14.3012 19.7509 14.3012 17.6229C14.3012 15.2565 16.2044 13.3387 18.552 13.3387C20.9 13.3387 22.8029 15.2565 22.8029 17.6229Z",
    fill: "#F6F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4427 56.146L13.4425 26.0927C13.0806 26.1071 12.6997 26.1195 12.3088 26.1229C12.2568 26.1233 12.2053 26.1245 12.1531 26.1245C11.2004 26.1212 10.1913 26.0649 9.18906 25.7423C8.19891 25.4323 7.15812 24.7547 6.57207 23.6236C6.18043 22.8801 5.99925 22.008 6 21.0476C6.00151 19.999 6.20631 18.8259 6.62062 17.4494C6.70082 17.1839 6.85153 16.9455 7.05645 16.76C7.26138 16.5746 7.51271 16.4491 7.78327 16.3972V6.5H8.47606V7.1114C9.03358 6.82427 10.9703 6.0017 12.5693 7.45204C14.4586 9.16572 17.0722 7.70567 17.0722 7.70567C17.0722 7.70567 16.7674 14.6996 11.7823 11.7046C9.94231 10.5991 8.88905 11.7913 8.47625 12.4588V16.4283C8.48645 16.4311 8.49646 16.4327 8.50667 16.4359C8.89012 16.5535 9.21152 16.8199 9.40018 17.1763C9.58883 17.5327 9.62931 17.9501 9.51269 18.3366C9.15676 19.5118 9.02168 20.4133 9.02281 21.048C9.02357 21.6358 9.12974 21.9819 9.24196 22.1952C9.35815 22.4069 9.48058 22.5299 9.70521 22.6644C10.1394 22.9355 11.0744 23.0897 12.1531 23.0783C12.3368 23.0785 12.5245 23.0737 12.7131 23.0688C13.3791 23.0507 14.0666 23.0117 14.7357 23.0025C14.7905 22.996 14.8463 22.992 14.9027 22.992H22.2019C22.2219 22.992 22.2416 22.9943 22.261 22.9951C22.6009 22.9985 23.1722 23.0714 23.8223 23.4016C24.493 23.7388 25.219 24.3478 25.8398 25.2971C27.0816 27.2098 27.9923 30.3902 28 36.1375C28 37.2527 27.9645 38.4646 27.8882 39.7849C27.8648 40.1882 27.6834 40.5657 27.384 40.8342C27.0845 41.1028 26.6915 41.2405 26.2914 41.217C25.4578 41.1675 24.8217 40.4472 24.8705 39.6075C24.9434 38.3407 24.977 37.1872 24.977 36.1373C24.9785 32.3276 24.5306 29.8869 23.9982 28.3993C23.9002 28.1245 23.788 27.8552 23.6619 27.5923V56.146C23.6619 57.4465 22.6158 58.5 21.3258 58.5C20.0362 58.5 18.9901 57.4465 18.9901 56.146V38.9574H18.1145V56.146C18.1145 57.4465 17.0684 58.5 15.7784 58.5C14.4888 58.5 13.4427 57.4465 13.4427 56.146Z",
    fill: "#F6F5F8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#F6F5F8",
    strokeOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25875_12132"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.2c4443a90d00c1c91e206b8ab6dc052a.svg";
export { ForwardRef as ReactComponent };